import styled from '@emotion/styled';

import Icon from 'components/global/Icon';

import { Breakpoints } from 'utils/const.styles';

export const ScoreCardWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.3rem;
`;
export const ScoreCard = styled.div`
	display: flex;
	align-items: center;

	&.x-small {
		gap: 0.5rem;

		> .typography {
			font-size: 1.29rem; // 12px
		}
	}
	&.small {
		gap: 0.6rem;

		> .typography {
			font-size: 1.51rem; // 14px
		}
	}
	&.medium {
		gap: 0.7rem;

		> .typography {
			font-size: 1.94rem; // 18px
		}
	}
	&.large {
		gap: 0.8rem;

		> .typography {
			font-size: 2.37rem; // 22px
		}
	}
	&.x-large {
		gap: 0.9rem;

		> .typography {
			font-size: 2.8rem; // 26px
		}
	}
	&.xx-large {
		gap: 1rem;

		> .typography {
			font-size: 3.23rem; // 30px
		}
	}
	&.xxx-large {
		gap: 1.1rem;

		> .typography {
			font-size: 3.66rem; // 34px
		}
	}
`;

export const ScoreStars = styled.div`
	display: flex;
	color: var(--yellow);
	transition: all 0.1s ease-in-out;
	overflow: hidden;
	flex-wrap: wrap;

	.icon {
		color: var(--yellow) !important;
	}

	&.x-small {
		gap: 0.1rem;
	}
	&.small {
		gap: 0.3rem;
	}
	&.medium {
		gap: 0.5rem;
	}
	&.large {
		gap: 0.7rem;
	}
	&.x-large {
		gap: 0.9rem;
	}
	&.xx-large {
		gap: 1.1rem;
	}
	&.xxx-large {
		gap: 1.3rem;
	}
`;

export const StyledIcon = styled(Icon)`
	cursor: ${({ disabled }) => (disabled ? '' : 'pointer')};
	transition: transform 0.2s;
	display: block;

	${({ disabled }) =>
		!disabled &&
		`&:hover {
			transform: scale(1.1);
		}`}

	// must be between 20 and 80
	${({ percent }) =>
		percent &&
		`
			position: absolute;
			clip-path: inset(0 ${(100 - percent * 10) * 0.6 + 20}% 0 0);
		`}

	// must be between 20 and 80
	body[dir='rtl'] & {
		${({ percent }) =>
			percent &&
			`
			position: absolute;
			clip-path: inset(0 0 0 ${(100 - percent * 10) * 0.6 + 20}%);
		`}
	}
`;

export const FractionalStarContainer = styled.div`
	cursor: ${({ disabled }) => (disabled ? '' : 'pointer')};
`;

export const ScoreNps = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	width: 6.45rem;
	height: 6.45rem;
	background-color: var(--black-10);
	font-size: 2rem;
	cursor: pointer;
	transition: all 0.1s ease-in-out;

	&:hover:not(.disabled) {
		background-color: var(--${(props) => props.background}-90);

		> .typography {
			color: var(--white);
		}
	}

	&.selected {
		background-color: var(--${(props) => props.selectedBackground});

		> .typography {
			color: var(--white);
		}
	}

	&.disabled {
		cursor: not-allowed;
	}

	@media ${Breakpoints.mobileLandscape} {
		width: 6.1rem;
		height: 6.1rem;
	}
`;

export const RateDescription = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;
